import { render, staticRenderFns } from "./billingDetail.vue?vue&type=template&id=3588db28&scoped=true"
import script from "./billingDetail.vue?vue&type=script&lang=js"
export * from "./billingDetail.vue?vue&type=script&lang=js"
import style0 from "./billingDetail.vue?vue&type=style&index=0&id=3588db28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588db28",
  null
  
)

export default component.exports